import { render, staticRenderFns } from "./RFooter.vue?vue&type=template&id=4bab6492&scoped=true"
import script from "./RFooter.vue?vue&type=script&lang=js"
export * from "./RFooter.vue?vue&type=script&lang=js"
import style0 from "./RFooter.vue?vue&type=style&index=0&id=4bab6492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab6492",
  null
  
)

export default component.exports